// src/api/ticketStatusHistoryService.js
// -----------------------------------------------------------------------------
// In-memory mock service for Ticket_Status_History_TBL.
// Performs full CRUD operations locally to run without active database connection.
// -----------------------------------------------------------------------------

let mockHistory = [
  {
    historyID: 1,
    ticketID: 1,
    fromStatusID: 1, // Open
    toStatusID: 2, // In Progress
    changedBy: 1, // Admin User (e.g. John Doe)
    changedDttm: '2026-02-05T10:00:00Z',
  },
  {
    historyID: 2,
    ticketID: 1,
    fromStatusID: 2, // In Progress
    toStatusID: 3, // Resolved
    changedBy: 2, // PM User (e.g. Jane Smith)
    changedDttm: '2026-02-06T15:30:00Z',
  },
  {
    historyID: 3,
    ticketID: 2,
    fromStatusID: 1, // Open
    toStatusID: 2, // In Progress
    changedBy: 2, // PM User
    changedDttm: '2026-02-07T09:15:00Z',
  },
];

const ticketStatusHistoryService = {
  getAll: (params = {}) => {
    let list = [...mockHistory];

    if (params.ticketID) {
      list = list.filter((h) => Number(h.ticketID) === Number(params.ticketID));
    }
    if (params.search) {
      const q = String(params.search).toLowerCase();
      // Search by ticket id or changer name (via simulated lookup)
      list = list.filter(
        (h) =>
          String(h.ticketID).includes(q) ||
          String(h.historyID).includes(q)
      );
    }

    return Promise.resolve({ data: list });
  },

  getById: (historyID) => {
    const item = mockHistory.find((h) => h.historyID === Number(historyID));
    return Promise.resolve({ data: item || null });
  },

  create: (payload) => {
    const newID = mockHistory.length > 0 ? Math.max(...mockHistory.map((h) => h.historyID)) + 1 : 1;
    const newRecord = {
      historyID: newID,
      ticketID: payload.ticketID ? Number(payload.ticketID) : null,
      fromStatusID: payload.fromStatusID ? Number(payload.fromStatusID) : null,
      toStatusID: payload.toStatusID ? Number(payload.toStatusID) : null,
      changedBy: payload.changedBy ? Number(payload.changedBy) : 1, // defaults to current logged-in user
      changedDttm: new Date().toISOString(),
    };
    mockHistory.push(newRecord);
    return Promise.resolve({ data: newRecord });
  },

  update: (historyID, payload) => {
    const index = mockHistory.findIndex((h) => h.historyID === Number(historyID));
    if (index !== -1) {
      mockHistory[index] = {
        ...mockHistory[index],
        ticketID: payload.ticketID ? Number(payload.ticketID) : mockHistory[index].ticketID,
        fromStatusID: payload.fromStatusID ? Number(payload.fromStatusID) : mockHistory[index].fromStatusID,
        toStatusID: payload.toStatusID ? Number(payload.toStatusID) : mockHistory[index].toStatusID,
        changedBy: payload.changedBy ? Number(payload.changedBy) : mockHistory[index].changedBy,
      };
      return Promise.resolve({ data: mockHistory[index] });
    }
    return Promise.reject({ response: { data: { message: 'History record not found.' } } });
  },

  remove: (historyID) => {
    mockHistory = mockHistory.filter((h) => h.historyID !== Number(historyID));
    return Promise.resolve({ data: { success: true } });
  },
};

export default ticketStatusHistoryService;
